// Výraznost škál Skici (CR-014 §1.1): čistá funkce nad payloadem (`z`, `pole`, `computed`).
// Jedna definice pro web (pořadí karet), doménu a worker placeného Portrétu (pořadí sekcí a vstup
// AI, CR-023 §3). Výsledek se nepřepočítává.

export interface ScaleFacts {
  readonly id: string;
  readonly z: number | null;
  /** Pól z payloadu: `null` ve středním (neutrálním) pásmu. */
  readonly pole: string | null;
  readonly computed: boolean;
  readonly lowReliability: boolean;
}

export interface Prominence {
  /** Sekce 5: výrazné škály, nebo dvě nejvzdálenější, když jsou výrazné méně než dvě. */
  readonly prominent: readonly string[];
  /** Sekce 6: ostatní spočítané škály. */
  readonly balanced: readonly string[];
  /** Škály s málo odpověďmi: ani výrazné, ani vyrovnané. */
  readonly notComputed: readonly string[];
  /** Sekce 5 obsahuje i vyrovnané škály („Kam se nejvíc přikláníš“). */
  readonly leaning: boolean;
}

/**
 * Výraznost (CR-014 §1.1): výrazná = `pole` ≠ `null`. Řazení `|z|` sestupně, při shodě škála
 * s nízkou reliabilitou za přesnější, pak pořadí vstupu (pořadí škál v definici).
 */
export function prominence(scales: readonly ScaleFacts[]): Prominence {
  const computed = scales.map((s, index) => ({ ...s, index })).filter((s) => s.computed && s.z !== null);
  computed.sort((a, b) => Math.abs(b.z ?? 0) - Math.abs(a.z ?? 0) || Number(a.lowReliability) - Number(b.lowReliability) || a.index - b.index);
  const notComputed = scales.filter((s) => !s.computed || s.z === null).map((s) => s.id);
  const withPole = computed.filter((s) => s.pole !== null);
  if (withPole.length >= 2) {
    return { prominent: withPole.map((s) => s.id), balanced: computed.filter((s) => s.pole === null).map((s) => s.id), notComputed, leaning: false };
  }
  const top = computed.slice(0, 2).map((s) => s.id);
  return { prominent: top, balanced: computed.slice(2).map((s) => s.id), notComputed, leaning: computed.length > 0 };
}

